import React from "react";
import DisplayError from "../../common/DisplayError";
import "./CheckAgreementField.css";
import type { StandardFieldProps } from "../types";
import { useFormContext } from "react-hook-form";

// Props for CheckAgreementField
export interface CheckAgreementFieldProps extends StandardFieldProps {
  onClick?: (ev: React.MouseEvent<HTMLInputElement>) => void;
}

const CheckAgreementField: React.FC<CheckAgreementFieldProps> = (props) => {
  const { field, error, validationsObject, onClick } = props;
  const form = useFormContext();
  const { setValue, register } = form;

  let classes = "checkmark";
  if (error) {
    classes = classes + " error";
  }

  const handleChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    ev.persist();
    setValue(field.name, ev.target.checked);
  };

  return (
    <div className="checkbox-container checkbox-warning-filled mb-2 pr-4">
      <label className="form-check-label checkbox-label">
        <input
          type="checkbox"
          id={props.name || field.name}
          className={"form-check-input"}
          onClick={onClick}
          {...register(field.name, {
            ...validationsObject,
            onChange: (e) => {
              handleChange(e);
            },
          })}
        />
        <span className={classes}></span>
        <div className="field-label">{field.label}</div>
      </label>
      <DisplayError
        errorCondition={error}
        errorMessage={error && error.message}
      />
    </div>
  );
};

export default CheckAgreementField;
